import {
  EICStatusEnum,
  PremiseRequest,
  RequestStatusEnum,
} from "../Premises/types";
import { formatDate, getFormattedAddress } from "../Premises/helpers";
import { DraftsTableRow, DraftsTableRows, SortByEnum } from "./types";

export const mapRequestsToDraftTableRows = (
  requests: PremiseRequest[]
): DraftsTableRows => {
  return requests.map((request) => {
    const addressObj = request.premise;
    const premiseRequestSummary = request.premise_request_summary;
    const siteDetails = addressObj.site_details;
    const address = getFormattedAddress(addressObj);

    return {
      serviceType: premiseRequestSummary.service_type,
      connectionType: premiseRequestSummary.connection_type,
      address,
      id: premiseRequestSummary.request_id,
      lastEdited: formatDate(premiseRequestSummary.updated),
      status: getStatusIconString(premiseRequestSummary.request_status),
      statusText: getStatusText(
        premiseRequestSummary.request_status,
        premiseRequestSummary.collaborator_name,
        premiseRequestSummary.eic_status ?? EICStatusEnum.EIC_COMM_UNUSED
      ),
      state: siteDetails.state,
      requestType: premiseRequestSummary.request_type,
      requestStatus: premiseRequestSummary.request_status,
      requestChannel: premiseRequestSummary.request_channel,
      eicStatus: premiseRequestSummary.eic_status,
    };
  });
};

export const getStatusIconString = (
  requestStatus: RequestStatusEnum
): string => {
  const statusMessages = {
    [RequestStatusEnum.DRAFT]: "pencil",
    [RequestStatusEnum.DRAFT_ASSIGNED]: "assigned",
  };
  return statusMessages[requestStatus as keyof typeof statusMessages] || "none";
};

export const getStatusText = (
  requestStatus: RequestStatusEnum,
  collaborator_name?: string | undefined,
  eicStatus?: EICStatusEnum | undefined
): string => {
  if (requestStatus === RequestStatusEnum.DRAFT) {
    switch (eicStatus) {
      case EICStatusEnum.EIC_COMM_SENT:
        return "Waiting on account holder";
      case EICStatusEnum.EIC_ACCEPTED:
        return "Account holder details received";
      default:
        return "Draft";
    }
  }
  switch (eicStatus) {
    case EICStatusEnum.EIC_COMM_SENT:
      return "Waiting on account holder";
    default:
      return `Assigned to ${collaborator_name}`;
  }
};

export const mapDraftsTableRowKeyToSortByEnum = (
  key: keyof DraftsTableRow
): SortByEnum | null => {
  const keyToSortByEnumMap: Record<keyof DraftsTableRow, SortByEnum | null> = {
    serviceType: null,
    connectionType: SortByEnum.CONNECTION_TYPE,
    address: SortByEnum.ADDRESS,
    id: SortByEnum.REQUEST_ID,
    lastEdited: SortByEnum.UPDATED,
    status: SortByEnum.DRAFT_STATUS,
    statusText: SortByEnum.DRAFT_STATUS,
    state: null,
    requestType: null,
    requestChannel: null,
    eicStatus: null,
  };

  return keyToSortByEnumMap[key] || null;
};
